export enum AirbnbStandardFeeType {
  resortFee = 'PASS_THROUGH_RESORT_FEE',
  managementFee = 'PASS_THROUGH_MANAGEMENT_FEE',
  communityFee = 'PASS_THROUGH_COMMUNITY_FEE',
  linenFee = 'PASS_THROUGH_LINEN_FEE',
  petFee = 'PASS_THROUGH_PET_FEE',
  cleaningFee = 'PASS_THROUGH_CLEANING_FEE',
  securityDeposit = 'PASS_THROUGH_SECURITY_DEPOSIT',
}
